{
  "title": "Settings",
  "loading": "Loading…",
  "actions": { "save": "Save", "close": "Close", "cancel": "Cancel" },
  "roles": { "owner": "Owner", "partner": "Partner", "caregiver": "Caregiver" },
  "home": {
    "title": "Family",
    "babiesLabel": "Babies",
    "addBaby": "Add baby",
    "tour": "Learn the app",
    "tourSub": "7 short tours with quick checks",
    "born": "Born {{date}}",
    "people": "People",
    "groupBaby": "{{name}}'s plan",
    "steps_one": "{{count}} step",
    "steps_other": "{{count}} steps",
    "routineSub": "{{min}} min in all",
    "sleepBoth": "Up at {{wake}}, bed at {{bed}}",
    "sleepWake": "Up at {{wake}}",
    "sleepBed": "Bed at {{bed}}",
    "sleepAge": "Typical times for this age",
    "groupApp": "App",
    "remindersOn": "{{count}} on",
    "remindersOff": "Off",
    "sounds": "Sounds and night mode",
    "units": "Units",
    "unitsShort": { "imperial": "oz · lb · °F", "metric": "ml · kg · °C" },
    "groupAccount": "Account",
    "planActive": "Active",
    "planPlus": "Active, with extras",
    "planNone": "Not active",
    "signedInAs": "Signed in as {{email}}",
    "signOut": "Sign out",
    "signOutAll": "Sign out on all devices",
    "signOutAllTitle": "Sign out everywhere?",
    "signOutAllBody": "You'll be signed out on every phone and computer, including this one. Your data stays.",
    "unsyncedTitle": "Some logs haven't synced yet",
    "unsyncedBody": "Your latest logs are only on this phone because it's offline. If you sign out now, they'll be deleted from this phone. Connect to the internet first, then sign out.",
    "unsyncedConfirm": "Sign out anyway"
  },
  "baby": {
    "title": "Baby",
    "saved": "Saved",
    "switch": "Your babies",
    "caregiverNote": "Only parents can change these details.",
    "add": "Add another baby",
    "addTitle": "Add a baby",
    "addSubmit": "Add baby"
  },
  "routine": {
    "title": "Bedtime routine",
    "lead": "The steps you follow every evening. Together they take {{total}} minutes.",
    "kinds": {
      "bath": "Bath",
      "pajamas": "Pajamas",
      "massage": "Massage",
      "feed": "Feed",
      "book": "Book",
      "song": "Song",
      "cuddle": "Cuddle",
      "bed": "Bed"
    },
    "min": "{{n}} min",
    "minutesFor": "Minutes for {{name}}",
    "less": "Shorter",
    "more": "Longer",
    "up": "Move {{name}} earlier",
    "down": "Move {{name}} later",
    "remove": "Remove {{name}}",
    "moved": "{{name}} is now step {{pos}}",
    "removed": "{{name}} removed",
    "added": "{{name}} added before Bed",
    "bedLast": "Always last",
    "add": "Add a step",
    "addTitle": "Add a step",
    "applies": "Changes start tomorrow, or when you restart tonight's routine.",
    "saved": "Routine saved",
    "caregiverNote": "Only parents can change the routine."
  },
  "sleep": {
    "title": "Sleep times",
    "lead": "When {{name}} usually wakes up and goes to bed. The plan builds naps around these.",
    "wake": "Wake-up time",
    "bedtime": "Bedtime",
    "bedtimeHint": "When baby should be asleep. The routine starts before it.",
    "useAge": "Use times for this age instead",
    "ageBased": "No times set: we use typical times for this age.",
    "saved": "Sleep times saved",
    "caregiverNote": "Only parents can change sleep times.",
    "quizLead": "Things changed? Answer the sleep questions again and get a fresh plan.",
    "retake": "Redo the sleep questions"
  },
  "notifications": {
    "title": "Reminders",
    "what": "Remind me about",
    "nap": "Nap reminders",
    "bedtime": "Bedtime reminders",
    "bedtimeHint": "Sent when it's time to start the routine.",
    "lead": "How early",
    "min": "{{n}} min",
    "device": "This phone",
    "push": "Notifications on this phone",
    "pushHint": "Each phone is turned on separately.",
    "howInstall": "How to add it",
    "installTip": "Reminders are most reliable from the Home Screen app."
  },
  "preferences": {
    "title": "Units and language",
    "unitsLabel": "Units",
    "units": { "imperial": "US", "metric": "Metric" },
    "unitsHint": { "imperial": "oz, lb, inches, °F", "metric": "ml, kg, cm, °C" },
    "language": "Language",
    "languageHint": "More languages are coming."
  },
  "subscription": {
    "title": "Subscription",
    "have": "What you have",
    "features": { "baby_access_app": "Baby Plan app", "baby_access_coach": "Sleep coach chat", "baby_access_book": "Handbooks: all 5 (PDF)" },
    "active": "Active",
    "notIncluded": "Not included",
    "messagesLeft_one": "{{count}} message left",
    "messagesLeft_other": "{{count}} messages left",
    "viaFamily": "Your access comes from your family's subscription.",
    "more": "Add more",
    "offersError": "Offers couldn't load. Try again later.",
    "offers": {
      "annual": { "title": "Switch to yearly", "body": "One payment for the whole year. Save compared with paying monthly." },
      "book": { "title": "Baby Plan handbooks", "body": "All 5 handbooks as PDFs: the first, second and third year, sleep from birth to 3, and a book for you, the parent. With pictures, to keep and print, yours for good." },
      "coach": { "title": "Sleep coach chat", "body": "Ask anything about your baby's sleep, any time." }
    },
    "period": { "month": "{{amount}} a month", "year": "{{amount}} a year", "once": "{{amount}} once" },
    "buyOneclick": "Buy with saved card",
    "buyCard": "Pay with card",
    "buying": "One moment…",
    "done": "Done! It's yours.",
    "pending": "Checking your payment. Please don't pay again.",
    "slow": "Your payment is still processing. Access will appear by itself. If you were charged and nothing changes, write to support@getbabyplan.com.",
    "checkoutHint": "Pay with {{email}} so the purchase reaches this account.",
    "checkoutFailed": "The payment form didn't load.",
    "openWhop": "Open it on Whop",
    "errors": {
      "generic": "That didn't work. You weren't charged. Try again later.",
      "offline": "You're offline. You weren't charged.",
      "offer_not_available": "This offer isn't available for your account.",
      "offer_not_configured": "This offer isn't ready yet. Try again later."
    }
  },
  "privacy": {
    "title": "Data and privacy",
    "exportTitle": "Your data",
    "exportLead": "Download everything we keep about you and your babies.",
    "exportJson": "Download all my data",
    "exportCsv": "{{name}}'s log as a spreadsheet",
    "exportHint": "The spreadsheet opens in Excel, Numbers or Google Sheets, and you can share it with your pediatrician.",
    "preparing": "Preparing…",
    "consentTitle": "Health data consent",
    "consentGiven": "You agreed that Baby Plan may store health data (version {{version}}).",
    "consentMissing": "Baby Plan needs your consent to save sleep, feeding and other logs.",
    "consentSaved": "Thanks. Logging is on again.",
    "withdraw": "Withdraw consent",
    "withdrawTitle": "Withdraw consent?",
    "withdrawBody1": "Baby Plan will stop saving new logs and quiz answers until you agree again.",
    "withdrawBody2": "What's already saved stays until you delete your account.",
    "withdrawConfirm": "Withdraw",
    "withdrawn": "Consent withdrawn",
    "history": "History",
    "action": { "given": "Agreed", "withdrawn": "Withdrawn" },
    "deleteTitle": "Delete account",
    "deleteLead": "You'll see what happens to your family before anything is deleted.",
    "deleteOpen": "Delete my account…",
    "deleteSheetTitle": "Delete your account?",
    "deleteGrace": "You'll be signed out on every device. We keep your data for {{days}} days in case you change your mind, then delete it for good.",
    "deleteCrm": "Deleting your account here doesn't change your purchases. To remove your login and payment history too, write to support@getbabyplan.com.",
    "deleteUnderstand": "I understand.",
    "deleteConfirm": "Delete my account",
    "deleteKeep": "Keep my account",
    "deletedTitle": "Your account will be deleted",
    "deletedBody": "Everything is deleted on {{date}}.",
    "deletedRestore": "Changed your mind? Sign in before then and choose Keep my account.",
    "deletedOk": "OK",
    "yourBabies": "Your babies",
    "partner": "your partner",
    "outcome": {
      "transfer": "{{babies}}: the family moves to {{name}}, with all logs.",
      "delete": "{{babies}}: the family and all its logs are deleted.",
      "caregivers_one": "{{count}} caregiver loses access.",
      "caregivers_other": "{{count}} caregivers lose access.",
      "leave": "{{babies}}: you leave this family. It stays as it is."
    },
    "errors": {
      "rate_limited": "You've downloaded a few times already. Try again in an hour.",
      "offline": "You're offline. Connect and try again.",
      "baby_not_found": "That baby's log isn't available.",
      "generic": "Something went wrong. Please try again."
    }
  },
  "restore": { "title": "Your account", "body": "Your account is set to be deleted on {{date}}.", "keep": "Keep my account", "leave": "Sign out" },
  "purchaseReturn": {
    "checking": "Confirming your payment",
    "checkingBody": "This takes a few seconds. Please don't pay again.",
    "done": "All set!",
    "slow": "Still processing",
    "slowBody": "Access will appear by itself. If you were charged and nothing changes, write to {{email}}.",
    "back": "Back to Baby Plan"
  },
  "help": { "title": "Help and feedback", "sub": "Answers, ideas, email support" },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "offline": "You're offline. Connect and try again.",
    "role_not_allowed": "Only parents can change this.",
    "validation_error": "Check the fields and try again.",
    "feature_required": "This needs an active Baby Plan subscription."
  }
}
